import StorageAbstractFactory from '@infrastructure/cache';

export type ChangeLanguageCommand = {
  lang: 'ca' | 'es' | 'en';
};

export default function onChangeLanguage({ i18n }) {
  return function ({ lang }: ChangeLanguageCommand) {
    if (['ca', 'es', 'en'].includes(lang)) {
      StorageAbstractFactory.createLocalStorage().setItem('i18nextLng', lang);
      i18n.changeLanguage(lang);
    }
  };
}
